import { render, staticRenderFns } from "./PressEntryThumbAbout.vue?vue&type=template&id=9182f75c&scoped=true&lang=pug&"
import script from "./PressEntryThumbAbout.vue?vue&type=script&lang=js&"
export * from "./PressEntryThumbAbout.vue?vue&type=script&lang=js&"
import style0 from "./PressEntryThumbAbout.vue?vue&type=style&index=0&id=9182f75c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9182f75c",
  null
  
)

export default component.exports